import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postSendLowMaterials = createApi(`SendToS4MaterialsSlice`,"POST");

const SendToS4MaterialsSlice = createSlice({
  name: 'SendToS4MaterialsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postSendLowMaterials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSendLowMaterials.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postSendLowMaterials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SendToS4MaterialsSlice.reducer;